import React, { useEffect, useRef, useState } from "react";

import AbstractGradientsPng1 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41878.png";
import AbstractGradientsPng2 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41879.png";
import AbstractGradientsPng3 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41880.png";
import AbstractGradientsPng4 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41881.png";
import AbstractGradientsPng5 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41882.png";
import AbstractGradientsPng6 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41883.png";
import AbstractGradientsPng7 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41884.png";
import AbstractGradientsPng8 from "../../../../../assets/appearencePage/abstractGradiants/Rectangle 41885.png";

import { ReactComponent as LockIcon } from "../../../../../assets/MainPage/addBlock/lock.svg";
import { ReactComponent as LockIconDark } from "../../../../../assets/MainPage/addBlock/lock-dark.svg";

import { ReactComponent as DownArrowIcon } from "../../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../../assets/appearencePage/arrow-down-dark.svg";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-hot-toast";
import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";
import { useDispatch, useSelector } from "react-redux";
import { createBackgroundSettings } from "../../../../../redux/slices/appearance/createBackgroundSettingsSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../../../../hooks/useLocales";
import AppearanceDeleteButton from "../../../../../components/common/buttons/AppearanceDeleteButton";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

const fileTypes = ["png", "jpg", "jpeg", "gif", "ico"];
const simpleGradientsArr = [
  {
    id: 0,
    value: "bg-gradient-to-b from-[#9BF5BB] to-[#4F8BC1]",
  },
  {
    id: 1,
    value: "bg-gradient-to-b from-[#BC5FCB] to-[#7BC4E8]",
  },
  {
    id: 2,
    value: "bg-gradient-to-b from-[#ED5C86] to-[#AD4689]",
  },
  {
    id: 3,
    value: "bg-gradient-to-b from-[#D3321D] to-[#FFCF67]",
  },
  {
    id: 4,
    value: "bg-gradient-to-b from-[#F6C4ED] to-[#FFCF67]",
  },
  {
    id: 5,
    value: "bg-gradient-to-b from-[#6FE3E1] to-[#5257E5]",
  },
  {
    id: 6,
    value: "bg-gradient-to-b from-[#2C5364] via-[#203A43] to-[#0F2027]",
  },
  {
    id: 7,
    value: "bg-gradient-to-b from-[#232526] to-[#414345]",
  },
  {
    id: 8,
    value: "bg-gradient-to-b from-[#294861] to-[#0E1C26]",
  },
  {
    id: 9,
    value: "bg-gradient-to-b from-[#DDB4F6] to-[#8DD0FC]",
  },
  {
    id: 10,
    value: "bg-gradient-to-b from-[#FC859E] to-[#90A1FB]",
  },
  {
    id: 11,
    value: "bg-gradient-to-b from-[#1ED7B5] to-[#F0F9A7]",
  },
  {
    id: 12,
    value: "bg-gradient-to-b from-[#F55C7A] to-[#F6BC66]",
  },
  {
    id: 13,
    value: "bg-gradient-to-b from-[#F6C4ED] to-[#E1DAE6]",
  },
  {
    id: 14,
    value: "bg-gradient-to-b from-[#2A5470] to-[#4C4177]",
  },
  {
    id: 15,
    value: "bg-gradient-to-b from-[#30C5D2] to-[#471069]",
  },
  {
    id: 16,
    value: "bg-gradient-to-b from-[#2C5364] via-[#302B63] to-[#0F0C29]",
  },
  {
    id: 17,
    value: "bg-gradient-to-b from-[#FF5349] to-[#FF9E9D]",
  },
];

const abstractGradientsArr = [
  {
    id: 0,
    value: AbstractGradientsPng1,
  },
  {
    id: 1,
    value: AbstractGradientsPng2,
  },
  {
    id: 2,
    value: AbstractGradientsPng3,
  },
  {
    id: 3,
    value: AbstractGradientsPng4,
  },
  {
    id: 4,
    value: AbstractGradientsPng5,
  },
  {
    id: 5,
    value: AbstractGradientsPng6,
  },
  {
    id: 6,
    value: AbstractGradientsPng7,
  },
  {
    id: 7,
    value: AbstractGradientsPng8,
  },
];

const BackgroundAcc = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const [bgSubLoading, setBgSubLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useLocales();
  const modalRef = useRef();
  const iconRef = useRef();
  const colorDropDownRef = useRef();
  const colorDropDownBtnRef = useRef();

  const bgTypeDropDownRef = useRef();
  const bgTypeDropDownBtnRef = useRef();

  const [width, setWidth] = useState(window.innerWidth);

  const [bgTypeDropDown, setBgTypeDropDown] = useState(false);

  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );

  const paidUserCheck = paymenetBlocks === 1;

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [color, setColor] = useColor("#FF5F55");
  useEffect(() => {
    setBgColorHandler(color);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  const [bgTypeDropdown, setBgTypeDropdown] = useState(false);
  const [bgTypeAcc, setBgTypeAcc] = useState("simpleGradients");
  const [selectedDivSimpleGradients, setSelectedDivSimpleGradients] = useState({
    id: 0,
    value: "bg-gradient-to-br from-[#b865cd] to-[#7DC2E7]",
  });
  const [selectedDivAbstractGradients, setSelectedDivAbstractGradients] =
    useState({
      id: 0,
      value: AbstractGradientsPng1,
    });
  const [cutomColorBg, setCutomColorBg] = useState("#FF5F55");
  const [openBgColopicker, setOpenBgColopicker] = useState(false);
  const setBgColorHandler = (color) => {
    setCutomColorBg(color.hex);
  };
  const baseUrl = process.env.REACT_APP_API_URL;
  const [customImageShow, setCustomImageShow] = useState(null);
  const [cutomImageBg, setCutomImageBg] = useState(null);
  const handleChangeCutomImageBg = (file) => {
    setCutomImageBg(file);
    setCustomImageShow(URL.createObjectURL(file));
  };

  const selectDivSimpleGradients = (index, val) => {
    setSelectedDivSimpleGradients({
      ...selectedDivSimpleGradients,
      id: index,
      value: val,
    });
  };
  const selectDivAbstractGradients = (index, val) => {
    setSelectedDivAbstractGradients({
      ...selectedDivAbstractGradients,
      id: index,
      value: val,
    });
  };

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item.coloum_name === "background") {
        const value = JSON.parse(item.coloum_value);
        if (value?.backgroundType === "simpleGradients") {
          setBgTypeAcc("simpleGradients");
          let id;
          simpleGradientsArr.map((item) => {
            if (value.backgroundOptionVal === item.value) {
              return (id = item.id);
            } else {
              return null;
            }
          });
          selectDivSimpleGradients(id, value.backgroundOptionVal);
        } else if (value?.backgroundType === "abstractGradients") {
          setBgTypeAcc("abstractGradients");
          let id;
          abstractGradientsArr.map((item) => {
            if (value.backgroundOptionVal === item.value) {
              return (id = item.id);
            } else {
              return null;
            }
          });
          selectDivAbstractGradients(id, value.backgroundOptionVal);
        } else if (value?.backgroundType === "customColor") {
          setBgTypeAcc("customColor");
          setCutomColorBg(value?.backgroundOptionVal);
          setColor((color) => {
            return { ...color, hex: value?.backgroundOptionVal };
          });
        } else if (value?.backgroundType === "customImage") {
          setBgTypeAcc("customImage");
          setCustomImageShow(
            baseUrl + "/profile/" + value?.backgroundOptionVal
          );
        }
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        bgTypeDropdown &&
        modalRef.current &&
        !modalRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setBgTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bgTypeDropdown]);

  // Custom color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openBgColopicker &&
        colorDropDownRef.current &&
        !colorDropDownRef.current.contains(e.target) &&
        !colorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenBgColopicker(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openBgColopicker]);

  // type dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        bgTypeDropDown &&
        bgTypeDropDownRef.current &&
        !bgTypeDropDownRef.current.contains(e.target) &&
        !bgTypeDropDownBtnRef.current.contains(e.target)
      ) {
        setBgTypeDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bgTypeDropDown]);

  const submitHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    if (!bgTypeAcc) {
      toast.error("Please select a Background");
      return;
    } else {
      const formData = {
        userId: userId,
        linkId: linkId,
      };
      if (bgTypeAcc === "customColor") {
        // toast.success(cutomColorBg);
        formData.background_type = bgTypeAcc;
        formData.background_val = cutomColorBg;
      } else if (bgTypeAcc === "simpleGradients") {
        formData.background_val = selectedDivSimpleGradients?.value;
        formData.background_type = bgTypeAcc;
        // toast.success(selectedDivSimpleGradients?.val);
      } else if (bgTypeAcc === "abstractGradients") {
        formData.background_val = selectedDivAbstractGradients?.value;
        formData.background_type = bgTypeAcc;
        // toast.success(selectedDivAbstractGradients?.val?.value);
      } else if (bgTypeAcc === "customImage") {
        if (!cutomImageBg || cutomImageBg === null) {
          if (customImageShow) {
            return;
          } else {
            toast.error("Please select a Image");
            return;
          }
        } else {
          formData.background_val = cutomImageBg;
          formData.background_type = bgTypeAcc;
        }
      }
      setBgSubLoading(true);

      await dispatch(createBackgroundSettings(formData)).then(() => {
        dispatch(gettingSettingUpdataData(user));
        dispatch(getScreenPreviewSetting(pageName));
      });

      setBgSubLoading(false);
    }
  };

  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      userId: userId,
      linkId: linkId,
      background_val: "bg-gradient-to-br from-[#97f0bc] from-10% to-[#5290c1]",
      background_type: "simpleGradients",
    };
    setDeleteStylePending(true);

    await dispatch(createBackgroundSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });

    setDeleteStylePending(false);
  };

  return (
    <>
      <div
        ref={bgTypeDropDownBtnRef}
        className="relative bg-light_bg_v4 dark:bg-[#404040]  rounded-lg py-[13px] lg:py-[11px] px-[16px] lg:px-[15px] mt-[20px] lg:mt-[25px] xl:mt-[30px]"
      >
        <div
          onClick={() => {
            setBgTypeDropDown(!bgTypeDropDown);
          }}
          className="flex justify-between items-center cursor-pointer"
        >
          <div className="flex gap-2.5 items-center">
            <div className="text-heading_color dark:text-color_v1_dark text-small2 lg:text-small1">
              {/* selectedBgType */}
              {bgTypeAcc === "simpleGradients"
                ? translate("simple_gradients")
                : bgTypeAcc === "customColor"
                ? translate("custom_color")
                : bgTypeAcc === "customImage"
                ? translate("cms.custom_image")
                : "Select Background"}
            </div>
          </div>
          <div
            onClick={() => {
              setBgTypeDropDown(!bgTypeDropDown);
            }}
            className="text-xl "
          >
            {darkMode ? (
              <DownArrowIconDark className="h-[16px] w-[16px] lg:h-[18px] lg:w-[18px]" />
            ) : (
              <DownArrowIcon className="h-[16px] w-[16px] lg:h-[18px] lg:w-[18px]" />
            )}
          </div>
        </div>
        {bgTypeDropDown && (
          <div
            ref={bgTypeDropDownRef}
            className="absolute top-12 mb-20 left-0 w-full z-50 p-[5px] px-[7px] md:p-[7px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-36 overflow-y-auto"
          >
            <div
              onClick={() => {
                setBgTypeAcc("simpleGradients");
                setBgTypeDropDown(false);
              }}
              className="px-[7px] md:px-[10px] py-[5px] md:py-[7px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark   dark:hover:bg-dark-secondary hover:bg-light_bg_v4 cursor-pointer rounded-md"
            >
              {translate("simple_gradients")}
            </div>
            <div
              onClick={() => {
                setBgTypeAcc("customColor");
                setBgTypeDropDown(false);
              }}
              className="px-[7px] md:px-[10px] py-[5px] md:py-[7px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark   dark:hover:bg-dark-secondary cursor-pointer hover:bg-light_bg_v4 rounded-md"
            >
              {translate("custom_color")}
            </div>
            <div
              onClick={() => {
                paidUserCheck && setBgTypeAcc("customImage");
                setBgTypeDropDown(false);
              }}
              className="px-[7px] md:px-[10px] py-[5px] md:py-[7px] capitalize text-small2 flex justify-between lg:text-body_copy2 text-heading_color dark:text-color_v1_dark   dark:hover:bg-dark-secondary cursor-pointer hover:bg-light_bg_v4 rounded-md"
            >
              <p>{translate("cms.custom_image")}</p>{" "}
              <div className="text-xl flex items-center">
                {!paidUserCheck &&
                  (darkMode ? (
                    <LockIconDark className="h-[16px] w-[16px] lg:h-[18px] lg:w-[18px]" />
                  ) : (
                    <LockIcon className="h-[16px] w-[16px] lg:h-[18px] lg:w-[18px]" />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {bgTypeAcc === "simpleGradients" && (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[13px] xl:gap-5 mt-5">
          {simpleGradientsArr.map((item, i) => {
            return (
              <div
                key={i}
                className={`h-[180px] ${
                  selectedDivSimpleGradients?.id === item.id
                    ? "p-2 rounded-md border-2 border-black dark:border-color_v1_dark "
                    : ""
                } `}
              >
                <div
                  className={`rounded-md h-full w-fll ${item?.value} `}
                  onClick={() => {
                    selectDivSimpleGradients(item?.id, item?.value);
                  }}
                ></div>
              </div>
            );
          })}
        </div>
      )}
      {bgTypeAcc === "customColor" && (
        <div className="relative flex items-center justify-start w-full my-5">
          <div
            ref={colorDropDownBtnRef}
            onClick={() => setOpenBgColopicker(!openBgColopicker)}
            style={{
              background: cutomColorBg,
            }}
            className="border rounded-md mr-[16px] lg:mr-[19px] cursor-pointer min-w-[48px] min-h-[48px] w-[48px] h-[48px] relative"
          ></div>
          {openBgColopicker && (
            <div
              className="absolute top-0 lg:w-[80%] 2xl:w-[60%] w-full pb-5 "
              style={{ zIndex: "999999999" }}
            >
              <div
                ref={colorDropDownRef}
                className="border bg-white shadow-xl rounded-lg p-3"
              >
                <ColorPicker
                  color={color}
                  onChange={setColor}
                  hideInput={true}
                  height={150}
                />
                <div className="flex flex-wrap xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                  <div className="flex justify-center items-center gap-1 w-full">
                    <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                      <p>HEX</p>
                    </div>
                    <p>:</p>
                    <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                      <p>{color.hex}</p>
                    </div>
                  </div>
                  <div className="flex gap-1 justify-between w-full ">
                    <div className="border rounded-md px-1 py-0.5 text-small1">
                      {Math.round((color.rgb.a / 1) * 100)}%
                    </div>
                    <button
                      className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                      onClick={() => setOpenBgColopicker(false)}
                    >
                      DONE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="w-full overflow-hidden">
            <div className="text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
              {/* Color */}
              {translate("color")}
            </div>
            <div className="text-small2_b text-heading_color dark:text-color_v1_dark">
              <input
                value={cutomColorBg}
                type="text"
                className="focus:outline-none bg-transparent -mt-[8px]"
                onChange={(e) => {
                  setColor((color) => {
                    return { ...color, hex: e.target.value };
                  });
                }}
              />
            </div>
          </div>
        </div>
      )}
      {paidUserCheck && bgTypeAcc === "customImage" && (
        <div className="mt-5">
          {!customImageShow && (
            <FileUploader
              handleChange={handleChangeCutomImageBg}
              name="file"
              types={fileTypes}
              maxSize={2}
              onSizeError={(errorMessage) => toast.error(errorMessage)}
              onTypeError={(errorMessage) => toast.error(errorMessage)}
              children={
                <div>
                  <div className="flex items-center justify-center w-full">
                    <div className="flex flex-col items-center justify-center w-full py-[45px] px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary hover:bg-gray-100 dark:border-color_dark dark:hover:border-gray-500 dark:hover:bg-gray-600">
                      <div className="flex flex-col items-center justify-center">
                        <div className="mb-[11px] h-[36px] w-[36]">
                          {darkMode ? (
                            <ImagePlacholderDark />
                          ) : (
                            <ImagePlacholder />
                          )}{" "}
                        </div>
                        <p className="text-small3 mb-[5px] whitespace-nowrap text-font_light_color dark:text-color_v1_dark">
                          {/* Drop your image here or */}
                          {translate("drop_your_img")}, &nbsp;
                          <span className="text-small3_b text-main_color ">
                            {/* BROWSE IMAGE */}
                            {translate("browse_image")}
                          </span>
                        </p>
                        <p className="text-[10px] text-font_light_color tracking-[-0.3px] leading-[13px] dark:text-font_dark_color">
                          2 MB {/* maximum */}
                          {translate("cms.maximum")}(.png, .gif, .ico)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          )}
          {customImageShow && (
            <div>
              <div className="flex items-center">
                <div className="bg-light_bg_v4 rounded-lg cursor-pointer">
                  <img
                    className="h-[60px] w-[60px] sm:h-[68px] sm:w-[68px] object-cover rounded-lg"
                    src={customImageShow}
                    alt="..."
                  />
                </div>
                <div>
                  <FileUploader
                    handleChange={handleChangeCutomImageBg}
                    name="file"
                    types={fileTypes}
                    maxSize={2}
                    onSizeError={(errorMessage) => toast.error(errorMessage)}
                    onTypeError={(errorMessage) => toast.error(errorMessage)}
                    children={
                      <div className="ps-[15px] text-small2_b text-main_color cursor-pointer">
                        {/* CHOOSE ANOTHER */}
                        {translate("cms.choose_another")}
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="flex mt-[25px] items-center justify-end">
        <AppearanceDeleteButton
          isLoading={deleteStylePending}
          onClickHandler={deleteHandler}
        />
        <button
          onClick={() => submitHandler()}
          className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
            bgSubLoading ? "opacity-70" : ""
          } `}
        >
          {bgSubLoading ? (
            <svg
              aria-hidden="true"
              role="status"
              className="inline w-3 h-3 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            `${translate("biolink_title.save_cap")}`
          )}
        </button>
      </div>
    </>
  );
};

export default BackgroundAcc;
